/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {correctPostalCode} from '../api'

export const useMutationCorrectPostalCode = createReactQueryMutationHook('correctPostalCode', correctPostalCode)
